<script setup>
import Select from 'primevue/select';

import { useLocale } from '@/composables/locale';
const { localeOptions, getFlagClass, locale } = useLocale()

const flagClass = (l) => {
    return 'mr-2 ' + getFlagClass(l)
}
const getOption = (l) => {
    return localeOptions.find(option => option.value === l)
}

import { usePage } from '@inertiajs/vue3'
const page = usePage()

import { router } from '@inertiajs/vue3'
import { watch, ref } from 'vue';
watch(locale, (lang) => {
    let search = '/' + page.props.locale
    let replace = '/' + lang
    router.get(page.url.replace(search, replace))
});
</script>

<template>
    <div>
        <Select v-model="locale"
                :options="localeOptions"
                option-label="label"
                option-value="value"
                class="w-full"
        >
            <template #value="{value}">
                <div v-if="value" class="flex items-center">
                    <span :class="flagClass(value)"></span>
                    <div>{{ getOption(value)?.label }}</div>
                </div>
                <div v-else>Choose a Locale</div>
            </template>
            <template #option="{option}">
                <div class="flex items-center">
                    <span :class="flagClass(option.value)"></span>
                    <div>{{ option.label }}</div>
                </div>
            </template>
        </Select>
    </div>

</template>
